module.exports = __webpack_public_path__ + "img/powered-by.0fc6dec1.svg";